import {useEffect, useMemo, useState} from 'react';
import styles from '../SIZ.module.css';
import Input from '../../../../components/Input/Input';
import {CustomSelect} from '../../../../components/Select/Select';
import UniversalTable from '../../../../components/UTable/UTable';
import IconButton from '../../../../components/IconButton/IconButton';
import ErrorMessage from '../../../../components/ErrorMessage/ErrorMessage';
import useFillSelect from '../../../../hooks/useFillSelect.hook';
import {
	getAllDivisionsUrl,
	getAllMaterialsPaginatedUrl,
	getAllProfessionsUrl
} from '../../../../helpers/constants';
import {getColumns} from './table_columns';

export function SIZIssued({refreshKey, onEdit, onDelete}) {
	const [totalRecords, setTotalRecords] = useState(0);
	const [lastNameFilter, setLastNameFilter] = useState(undefined);
	const [selectedProfOption, setSelectedProfOption] = useState(null);
	const [selectedDivOption, setSelectedDivOption] = useState(null);

	const {
		error: errorProf,
		options: optionsProf
	} = useFillSelect({
		endpoint: getAllProfessionsUrl,
		labelField: 'title'
	});

	const {
		error: errorDiv,
		options: optionsDiv
	} = useFillSelect({
		endpoint: getAllDivisionsUrl,
		labelField: 'title'
	});

	const columns = useMemo(
		() => getColumns(styles, onEdit, onDelete),
		[onEdit, onDelete]
	);

	const [debouncedLastName, setDebouncedLastName] = useState(lastNameFilter);

	useEffect(() => {
		const timer = setTimeout(() => {
			setDebouncedLastName(lastNameFilter);
		}, 500);
		return () => clearTimeout(timer);
	}, [lastNameFilter]);

	let filters = {};
	if (lastNameFilter) {
		filters = {
			...filters,
			user__last_name__ilike: `%${debouncedLastName}%`
		};
	}
	if (selectedProfOption) {
		filters = {
			...filters,
			user__profession_id__in: selectedProfOption.value
		};
	}
	if (selectedDivOption) {
		filters = {
			...filters,
			user__division_id__in: selectedDivOption.value
		};
	}

	const ClearFilters = () => {
		setSelectedProfOption(null);
		setSelectedDivOption(null);
		setLastNameFilter('');
	};

	return (
		<div className={styles.outer_table}>
			<h2 className={styles.section_title}>Список выданных СИЗ по ведомости</h2>
			<ErrorMessage
				error={errorProf || errorDiv || undefined}
				onClose={() => {}}
			/>
			<div className={styles.table_toolbar}>
				<div className={styles.filters_table}>
					<Input
						value={lastNameFilter}
						onChange={(e) => setLastNameFilter(e.target.value)}
						placeholder="Поиск по фамилии"
					/>
					<CustomSelect
						value={selectedProfOption}
						options={optionsProf}
						placeholder="Профессия"
						onChange={setSelectedProfOption}
					/>
					<CustomSelect
						value={selectedDivOption}
						options={optionsDiv}
						placeholder="Подразделение"
						onChange={setSelectedDivOption}
					/>
					<IconButton onClick={ClearFilters} title="очистить фильтр">
						<img src="/icons/drop-filters-icon.svg" alt="очистить фильтр"/>
					</IconButton>
				</div>
				<div className={styles.table_count}>
					Записей: {totalRecords}
				</div>
			</div>
			<div className={styles.table}>
				<UniversalTable
					endpoint={getAllMaterialsPaginatedUrl}
					columns={columns}
					usePagination={true}
					initialPage={1}
					initialPageSize={20}
					filters={filters}
					onTotalRecordsChange={setTotalRecords}
					refreshKey={refreshKey}
				/>
			</div>
		</div>
	);
}
